export default "__VITE_ASSET__vq4mB938__"